/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {Element, Link, ScrollElement, scroller, scrollSpy} from 'react-scroll';

import {SetupGuideContext} from '../types';
import styles from '../index.module.styl';

const SCROLL_CONTAINER_ID = `scrollable`;

export {scrollSpy};

export const scrollToStep = (step, options = {skipAnimation: false}) => {
  const {skipAnimation} = options;

  scroller.scrollTo(step, {
    duration: 1000,
    delay: 0,
    offset: 0,
    smooth: skipAnimation ? false : `easeInOutQuart`,
    containerId: SCROLL_CONTAINER_ID,
  });
};

export const Scrollable = ({children, className}) => {
  return (
    <div className={className} id={SCROLL_CONTAINER_ID}>
      {children}
    </div>
  );
};

const Element = (props) => {
  const {active, children, parentBindings, ...rest} = props;
  return (
    <div {...rest} style={{opacity: active ? 1 : 0.2, pointerEvents: !active && `none`}}>
      {children}
    </div>
  );
};

export const ScrollableElement = ScrollElement(Element);

export const ScrollableLink = (props) => {
  const {setStep} = React.useContext(SetupGuideContext);

  const {targetStep, onSetActive, children, ...rest} = props;

  return (
    <Link
      activeClass={styles.current}
      onSetActive={() => setStep(targetStep)}
      to={targetStep}
      spy={true}
      containerId={SCROLL_CONTAINER_ID}
      {...rest}
    >
      {children}
    </Link>
  );
};
